import languages from "./languages.json";

export const supportedLngs = Object.keys(languages);

export const defaultLocale = "en";

export default languages;
